export const parseDate = (date: string | undefined) =>
	date ? new Date(date).toLocaleDateString('de-DE') : undefined
